import { SearchableDropdown } from "@vega-core/components/Form/Controls/SearchableDropdown/SearchableDropdown";
import { type OptionType } from "@vega-core/models/options";

import {
  type FilterState,
  FilterType,
  type FilterValue,
  type SearchableDropdownFilterConfig,
  type TableFilterId,
} from "../types";
import { getFilterValue } from "../utils/getFilterValue";

type Props = {
  filter: SearchableDropdownFilterConfig;
  isLoading: boolean;
  filterState: FilterState;
  onFilterChange: (filterId: string, value: FilterValue) => void;
  showLabel?: boolean;
  tableId: TableFilterId;
  disabled?: boolean;
};

export function SearchableDropdownFilter({
  filter,
  isLoading,
  filterState,
  onFilterChange,
  showLabel,
  tableId,
  disabled = false,
}: Props) {
  const optionValue = getFilterValue(
    filterState,
    filter.id,
    FilterType.SearchableDropdown,
  );

  // Use filter-level showLabel if specified, otherwise fall back to prop
  const shouldShowLabel = filter.showLabel ?? showLabel;

  return (
    <SearchableDropdown
      {...filter.props}
      disabled={Boolean(filter.props.disabled || isLoading || disabled)}
      label={shouldShowLabel ? filter.label : undefined}
      name={`${tableId}-${filter.id}`}
      onChange={(newValue: OptionType | undefined) => {
        onFilterChange(filter.id, newValue);
      }}
      options={filter.props.options}
      value={optionValue}
    />
  );
}
